import React from "react";
import Styles from './styles.module.scss'
import {useTranslation} from "react-i18next";



const TeamS1 = () => {
    const { t } = useTranslation();

    return (
        <section className={`${Styles.container}`}>
            <div className={`${Styles.contentWrap} ${Styles.pageContainer}`}>
                <div className={`${Styles.titleWrap}`}>
                    <div className={`${Styles.title}`}>{t('О команде')}</div>
                </div>
                <div className={`${Styles.note}`}>{t('TimeCapsule  – это междисциплинарная команда инженеров, исследователей и стратегов, объединённых одной задачей: создать инфраструктуру цифрового продолжения личности.')}</div>
                <div className={`${Styles.listWrap}`}>
                    <div className={`${Styles.listTitle}`}>{t('В команде проекта')}:</div>
                    <ul className={`${Styles.listBox}`}>
                        <li className={`${Styles.listBoxItem}`}>{t('специалисты по искусственному интеллекту и поведенческому моделированию')};</li>
                        <li className={`${Styles.listBoxItem}`}>{t('архитекторы блокчейн-протоколов и токенизированных экосистем')};</li>
                        <li className={`${Styles.listBoxItem}`}>{t('разработчики метавселенных и виртуальных сред')};</li>
                        <li className={`${Styles.listBoxItem}`}>{t('эксперты по кибербезопасности и защите данных')};</li>
                        <li className={`${Styles.listBoxItem}`}>{t('исследователи в области когнитивных наук и цифровой этики')}.</li>
                    </ul>
                </div>
                <div className={`${Styles.noteColored}`}>{t('Мы строим не просто продукт — мы проектируем новую форму существования.')}</div>
            </div>
        </section>
    );
};

export default TeamS1;